import React, { useCallback } from 'react';
import { Button, Modal } from 'react-bootstrap';

import { useDiscord } from '../../../discord/useDiscord';


/**
 * CC_MAIN_MENU (2026-05-27).
 *
 * Exit confirmation. Browser path drops the user back to `/` (the
 * Main Menu — same surface they were just on, which doubles as
 * "you can leave the tab now"). The Discord-embedded path can't
 * force the Activity iframe to close from inside, so it routes
 * back to `/` and the copy tells the user to use Discord's own
 * controls to fully close.
 */
export default function ExitConfirmModal({ app, show, onClose }) {
    const discord = useDiscord();
    const isEmbedded = Boolean(discord && discord.isEmbedded);

    const onConfirm = useCallback(() => {
        if (isEmbedded) {
            window.dispatchEvent(
                new CustomEvent('quick-router-event', { detail: '/' }));
            if (onClose) onClose();
            return;
        }
        window.location = '/';
        if (onClose) onClose();
    }, [isEmbedded, onClose]);

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Exit Haunted Space Hotel?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isEmbedded
                    ? 'Discord will keep the Activity available '
                      + 'in your voice channel. Use Discord\'s controls '
                      + 'to fully close it.'
                    : 'You can return any time at '
                      + 'manager.hauntedspacehotel.com.'}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-light" onClick={onClose}>
                    Cancel
                </Button>
                <Button variant="dread" onClick={onConfirm}>
                    Exit
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
